import React from 'react'
import PropTypes from 'prop-types'
import CustomLink from './CustomLink'

const VoipPayg = (props) => {
    return (
        <table width='100%' cellPadding='2'>
            <tbody>
                <tr>
                    <td>Untimed local calls:</td>
                    <td>10c/call</td>
                </tr>
                <tr>
                    <td>National Calls:</td>
                    <td>10c/call</td>
                </tr>
                <tr>
                    <td>Calls to Australian mobiles:</td>
                    <td>20c/min</td>
                </tr>
                <tr>
                    <td>Untimed 13/1300 Calls:</td>
                    <td>25c/call</td>
                </tr>
                <tr>
                    <td>Untimed 1223:</td>
                    <td>$1.00/call</td>
                </tr>
                <tr>
                    <td>Untimed 1225:</td>
                    <td>$1.65/call</td>
                </tr>
                <tr>
                    <td>Exetel to Exetel:</td>
                    <td>FREE</td>
                </tr>
                <tr>
                    <td><CustomLink to='https://www.exetel.com.au/phone/voip-international'>International Calls</CustomLink></td>
                    <td>&nbsp;</td>
                </tr>
            </tbody>
        </table>
    )
}

VoipPayg.propTypes = {

}

export default VoipPayg



// WEBPACK FOOTER //
// ./resources/js/components/VoipPayg.js